module.exports = __webpack_public_path__ + "static/media/indoor-outdoor-primary.6aedda2b.jpg";